import { Box, Grid, Stack, Typography } from "@mui/material";
import ManagementHeader from "../ManagementsUpdateHeader/ManagementsUpdateHeader";
import { useTranslation } from "react-i18next";
import CupsCifSelector from "../../CupsCifSelector/CupsCifSelector";
import { ManagementUpdateDomiciliationData } from "../../../core/models/managementsUpdate/managementUpdateDomiciliation/managementUpdateDomiciliation.model";
import { useContext, useEffect, useState } from "react";
import TotalEnergiesContext from "../../../core/store/context/TotalEnergiesContext";
import theme from "../../../muiTheme";
import "./ManagementUpdateDomiciliation.scss";
import ButtonElement from "../../UI/ButtonElement/ButtonElement";
import { useSearchParams } from "react-router-dom";
import ManagementsRequestState from "../../Managements/ManagementsRequestState/ManagementsRequestState";
import ManagementUploadFile from "../../Managements/ManagementsUploadFile/ManagementsUploadFile";
import {
  postCallCenter,
  postImportDocument,
} from "../../../core/services/managements/managements.service";
import { ManagementUpdateCup } from "../../../core/models/cupsCifSelector/cupsCifSelector.model";
import {
  MANAGEMENTS_ENVIRONMENT_GAS,
  MANAGEMENTS_ENVIRONMENT_LIGHT,
  MANAGEMENTS_STATE_ERROR,
  MANAGEMENTS_STATE_PENDING,
  MANAGEMENTS_SUBTYPE_DOMICILIATION_GAS,
  MANAGEMENTS_SUBTYPE_DOMICILIATION_LIGHT,
  MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT,
} from "../../../core/constants/constants";
import {
  ManagementRequestInfo,
  PostCallCenterRequestBody,
  RequestStateDescriptionData,
} from "../../../core/models/managements/managements.model";
import {
  initialManagementRequestInfo,
  getManagementsRequestTypeData,
  initialRequestStateData,
  formatOwnerDataCup,
} from "../../../utils/components/managements/managements.util";
import { formatDate } from "../../../utils/dateUtils/formatDate.util";
import { initialOwnerDataCup } from "../../../utils/ownerData/ownerData.util";
import { getSelectedCups } from "../../../utils/components/cupsCifSelector/cupsCifSelector.util";
import ManagementsCancelProcess from "../../Managements/ManagementsCancelProcess/ManagementsCancelProcess";
import { getRecipientId } from "../../../utils/components/services/services.util";

const ManagementUpdateDomiciliation = () => {
  const { t } = useTranslation();
  const {
    ownerData,
    userData,
    cifCupsState: { listCupsCifFiltered },
  } = useContext(TotalEnergiesContext);
  const [searchParms] = useSearchParams();
  const idCups = searchParms.get("idCups") || "";
  const [step, setStep] = useState<number>(idCups.length ? 0 : -1);
  const [updateDomiciliationData, setUpdateDomiciliationData] =
    useState<ManagementUpdateDomiciliationData>({
      idClient: "",
      isAdministrator: "",
      cups: [],
      contacts: [],
    });
  const [requestState, setRequestState] = useState<string>("");
  const [requestStateData, setRequestStateData] =
    useState<RequestStateDescriptionData>(initialRequestStateData);
  const [managementRequestInfo, setManagementRequestInfo] =
    useState<ManagementRequestInfo>(initialManagementRequestInfo);
  const [selectedCups, setSelectedCups] = useState<ManagementUpdateCup[]>([]);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const ownerDataCup =
    ownerData?.cups.find(
      ({ idCups: ownerDataIdCups }) => ownerDataIdCups.toString() === idCups
    ) || initialOwnerDataCup;

  useEffect(() => {
    if (ownerData) {
      const { isAdministrator, idAdministrator, idClient } = ownerData;
      setUpdateDomiciliationData((prevUpdateDomiciliationData) => ({
        ...prevUpdateDomiciliationData,
        idClient: isAdministrator ? idAdministrator : idClient,
        isAdministrator: isAdministrator.toString(),
      }));
    }

    if (idCups.length && ownerData) {
      setUpdateDomiciliationData((prevUpdateDomiciliationData) => ({
        ...prevUpdateDomiciliationData,
        cups: [formatOwnerDataCup(ownerDataCup)],
      }));
    }
  }, [idCups, ownerData, ownerDataCup]);

  const [file, setFile] = useState<File | null>(null);

  const handleSubmit = async () => {
    setStep(1);
    setIsLoading(true);
    let envirorment = 0;
    let subtype = 0;
    switch (updateDomiciliationData.cups[0].envirorment) {
      case "Luz":
        envirorment = MANAGEMENTS_ENVIRONMENT_LIGHT;
        subtype = MANAGEMENTS_SUBTYPE_DOMICILIATION_LIGHT;
        break;
      case "Gas":
        envirorment = MANAGEMENTS_ENVIRONMENT_GAS;
        subtype = MANAGEMENTS_SUBTYPE_DOMICILIATION_GAS;
        break;
      default:
        envirorment = 0;
    }

    const selectedCups = getSelectedCups(
      updateDomiciliationData.cups,
      listCupsCifFiltered
    );

    const requestBody: PostCallCenterRequestBody = {
      TextoIncidencia:
        "Cambio de domiciliación bancaria. El usuario ha incluido el documento SEPA.",
      IdTipoRegistro: envirorment,
      IdSubTipoReclamacion: subtype,
      CodigosContratos: selectedCups.map(
        ({ cupsContractCode }) => +cupsContractCode
      ),
      IdsContratos: selectedCups.map(({ cupsContractId }) => +cupsContractId),
      idUsuarioDestino: getRecipientId(envirorment, subtype),
    };

    if (userData) {
      try {
        const responseArray = await postCallCenter(requestBody, userData.token);
        if (Array.isArray(responseArray) && responseArray.length > 0) {
          const { IdCallCenter, IdCarpetaIncidencias } = responseArray[0];

          if (responseArray.some((contract) => contract.IdCallCenter === 0)) {
            throw new Error("One or more IdCallCenter values are 0");
          }

          file &&
            (await postImportDocument(
              IdCallCenter,
              IdCarpetaIncidencias,
              file,
              userData.token
            ));
          setRequestState(MANAGEMENTS_STATE_PENDING);
          setRequestStateData(
            getManagementsRequestTypeData(
              MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT,
              MANAGEMENTS_STATE_PENDING
            )
          );
          setManagementRequestInfo({
            registrarionDate: formatDate(new Date()),
            refferenceNumber: IdCallCenter.toString(),
          });
          setIsLoading(false);
        }
      } catch (error) {
        setRequestState(MANAGEMENTS_STATE_ERROR);
        setRequestStateData(
          getManagementsRequestTypeData(
            MANAGEMENTS_SUBTYPE_UPDATE_ADDRESS_TEXT,
            MANAGEMENTS_STATE_ERROR
          )
        );
        setIsLoading(false);
      }
    }
  };

  const [isModalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    <Box component="section" className="management-update-domiciliation">
      <ManagementHeader
        title={"Cambio de domiciliación bancaria"}
        step={step}
        cupsSelected={updateDomiciliationData.cups}
        ownerDataCup={ownerDataCup}
      />
      <Stack
        component="article"
        direction="column"
        justifyContent="center"
        alignItems="center"
        paddingTop={5}
        paddingBottom={10}
        bgcolor={{ md: theme.palette.grey[50] }}
      >
        {step === -1 && (
          <CupsCifSelector
            withContainer
            setUpdateCups={(selectedCups) => {
              setUpdateDomiciliationData((prevUpdateDomiciliationData) => ({
                ...prevUpdateDomiciliationData,
                cups: selectedCups,
              }));
              setStep(0);
              window.scrollTo({ top: 0, behavior: "auto" });
            }}
            selectedCups={selectedCups}
            setSelectedCups={setSelectedCups}
            title={"Gestiones.¿Dónde quieres aplicar el cambio?"}
            description={"Gestiones.El cambio se solicitará"}
          />
        )}
        {step === 0 && (
          <Grid container justifyContent="center" paddingX={2}>
            <Grid item md={8} lg={7} flex={1}>
              <Stack
                component="div"
                className="management-update-domiciliation__content-container"
                spacing={4}
              >
                <Stack component="div" spacing={2}>
                  <Typography variant="h3" component="p">
                    {t("Gestiones.Mandato SEPA")}
                  </Typography>
                  <Typography variant="body2" component="p">
                    {t("Gestiones.Adjuntar mandato SEPA")}
                  </Typography>
                </Stack>
                <Stack component="div" spacing={2}>
                  <ManagementUploadFile
                    title={t("Gestiones.Mandato SEPA")}
                    isRequired={true}
                    downloadDocumentType="01"
                    downloadButtonText={t("Gestiones.Descargar mandato SEPA")}
                    onFileUpload={(id, file) => {
                      setIsButtonDisabled(false);
                      setFile(file);
                    }}
                  />
                </Stack>

                <Box
                  component="div"
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  className="management-update-domiciliation__actions"
                  sx={{
                    flexDirection: { xs: "column", md: "row" },
                    flexWrap: "wrap",
                  }}
                >
                  <ButtonElement
                    onClick={() => {
                      handleSubmit();
                      window.scrollTo({ top: 0, behavior: "auto" });
                    }}
                    disabled={isButtonDisabled}
                  >
                    {t("Gestiones.Solicitar cambio de domiciliación")}
                  </ButtonElement>
                  <ButtonElement type="button" onClick={openModal} secondary>
                    {t("Cancelar")}
                  </ButtonElement>
                </Box>
              </Stack>
              <ManagementsCancelProcess
                open={isModalOpen}
                handleClose={closeModal}
              />
            </Grid>
          </Grid>
        )}
        {step === 1 && (
          <ManagementsRequestState
            showManagementRequestInfo
            isLoading={isLoading}
            state={requestState}
            managementRequestInfo={managementRequestInfo}
            title={requestStateData.title}
            description={requestStateData.description}
            descriptionExtra={requestStateData.descriptionExtra}
          />
        )}
      </Stack>
    </Box>
  );
};

export default ManagementUpdateDomiciliation;
